import { IonRouterOutlet } from '@ionic/react';

import { GetStarted, SignIn, Welcome } from '@/pages/authentication';
import { ROUTES } from '@/utils/routes';
import { Redirect, Route } from 'react-router-dom';

interface AuthenticationProps {}

const Authentication: React.FC<AuthenticationProps> = () => (
  <IonRouterOutlet>
    {/* Authentication Routes */}
    <Route exact path={ROUTES.ROOT}>
      <Welcome />
    </Route>
    <Route exact path={ROUTES.GET_STARTED}>
      <GetStarted />
    </Route>
    <Route exact path={ROUTES.SIGN_IN}>
      <SignIn />
    </Route>

    {/* Redirect non-authentication routes to root */}
    <Route>
      <Redirect to={ROUTES.ROOT} />
    </Route>
  </IonRouterOutlet>
);
export default Authentication;
